import { types } from "../action-types";

const initialState = {
    loading: false,
    error: false,
    bid_types_count: [],
    all_bids_status: [],
    response: false
};

const getCandidatesCountsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CANDIDATES_COUNTS_REQUESTED:
            return {
                ...state,
                loading: true,
                bid_types_count: [],
                all_bids_status: [],
                response: false
            };

        case types.GET_CANDIDATES_COUNTS_SUCCESS:
            return {
                ...state,
                loading: false,
                bid_types_count: action.payload.bid_types_count,
                all_bids_status: action.payload.allbids_status,
                error: false,
                response: true
            };
        case types.GET_CANDIDATES_COUNTS_FAILURE:
            return {
                ...state,
                loading: false,
                bid_types_count: [],
                all_bids_status: [],
                error: true,
            };
        default:
            return state;
    }
};

export default getCandidatesCountsReducer;
